
import {Component, Prop, Vue, Watch} from 'nuxt-property-decorator'
import ItemContainer from './items/ItemContainer.vue'
import EmailConfirm from './items/EmailConfirm.vue'

@Component({
  fetchOnServer: false,
  components: {
    EmailConfirm,
    ItemContainer,
  },
})
export default class NotifyBar extends Vue {
  @Prop() webPushId!: string;
  @Prop({type: Object, default: () => ({})}) options!: Record<string, any>;
  @Prop({type: String, default: 'gos-oplata'}) project: String

  showPopup = false;
  showNotify = false;

  get notificationCount() {
    return this.$store.getters['requisites/getCount'];
  }

  get menuOptions() {
    return {
      history: () => this.$router.push('/payment-history'),
      profile: () => this.$router.push('/profile'),
      autoPayment: false,
      savedCards: () => this.$router.push('/saved-cards'),
      webPush: () => {
        this.$eventBus.$emit('WebPushPermit')
        this.$eventBus2.$emit('WebPushPermit')
      },
      ...this.options,
    };
  }

  get user() {
    return this.$store.getters['user/getUser']
  }

  get menuLabels() {
    return {
      history: 'История оплат',
      profile: 'Реквизиты для проверки',
      webPush: 'Уведомления о задолженностях не подключены',
      autoPayment: 'Автопогашение',
      savedCards: 'Сохраненные карты',
    };
  }

  @Watch('showPopup')
  onPopupChange(value: boolean) {
    this.$emit('opened', value);
  }

  @Watch('$route', {deep: true})
  onRouteChange() {
    this.showNotify = !(
      // @ts-ignore
      this.$route.path.startsWith('/search/') ||
      // @ts-ignore
      ['payment', 'payment-fail', 'gibdd-incoming'].includes(this.$route.name)
    );
    this.switchFavicon()
  }

  async fetch() {
    await new Promise((resolve) => window.addEventListener('load', resolve, {once: true}))
    await this.$store.dispatch('requisites/getList')
    this.onRouteChange()
  }

  mounted() {
    document.body.onmousedown = () => {
      this.showPopup = false;
    }

    this.$eventBus.$on('showPopup', (val) => {
      this.showPopup = val.isShow
    })

    setTimeout(this.switchFavicon, 5000)
  }

  togglePopup() {
    this.showPopup = !this.showPopup
  }

  switchFavicon() {
    let n = 0;
    const favicon: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

    if (!favicon) {
      console.error("Favicon element not found.");
      return;
    }

    const interval = setInterval(() => {
      n = (n + 1) % 2;

      const count = this.$store.getters['requisites/getCount'];

      if (!this.showNotify) {
        clearInterval(interval);
        return
      }

      if (count === 0) {
        clearInterval(interval);
        return
      }

      if (n === 0) {
        favicon.href = '/favicon/favicon.ico';
      } else {
        if (count < 10) {
          favicon.href = `/favicon/favicon${count}.svg`;
        } else {
          favicon.href = '/favicon/faviconN.svg';
        }
      }
    }, 2000)
  }
}

